import React, { useState, useEffect } from "react";
import axios from "axios";
import "./TableGovernorates.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { fetchDataWithRetries } from "../../../Component/function/FunctionApi";
import useShowInvoice from "../../../hooks/invoice/ShowInvoice";
import useExportExcel from "../../../hooks/ExportExcel/userExportExcel";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";

const GovernoratesTable = () => {
  const [totalGovernoratesData, setTotalGovernoratesData] = useState([]);
  const [newGovernoratesData, setNewGovernoratesData] = useState([]);
  const [loadingTotal, setLoadingTotal] = useState(true);
  const [loadingNew, setLoadingNew] = useState(true);
  const [error, setError] = useState(null);
  const { handleExportToExcel } = useExportExcel();

  useEffect(() => {
    const fetchTotalInvoices = async () => {
      setLoadingTotal(true);
      try {
        await fetchDataWithRetries(
          "Invoice/get-total-invoice-with-governorate",
          setTotalGovernoratesData
        );
      } catch (error) {
        setError("Failed to fetch total invoices data.");
      } finally {
        setLoadingTotal(false);
      }
    };

    const fetchNewInvoices = async () => {
      setLoadingNew(true);
      try {
        await fetchDataWithRetries(
          "Invoice/get-total-invoice-with-status",
          setNewGovernoratesData
        );
      } catch (error) {
        setError("Failed to fetch new invoices data.");
      } finally {
        setLoadingNew(false);
      }
    };

    fetchTotalInvoices();
    fetchNewInvoices();
  }, []);

  const renderTable = (data, loading, type) => {
    if (loading) {
      return (
        <tr>
          <td colSpan="2">جارٍ تحميل البيانات...</td>
        </tr>
      );
    }

    if (data.length === 0) {
      return (
        <tr>
          <td colSpan="2">لا توجد بيانات {type}.</td>
        </tr>
      );
    }

    return data.data.map((item, index) => (
      <tr key={index}>
        <td>{item.governorate}</td>
        <td>{item.total}</td>
      </tr>
    ));
  };

  return (
    <div className="governorates-container">
      {error && <div className="error-message">{error}</div>}

      <Tabs className="tabs">
        <TabList>
          <Tab>اجمالي المحافظات اليوم</Tab>
          <Tab>اجمالي المحافظات حاله جديدة</Tab>
        </TabList>

        {/* Total governorates today */}
        <TabPanel>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">اجمالي المحافظات اليوم</h3>
            <Button 
              onClick={() => handleExportToExcel(totalGovernoratesData.data)} 
              variant="contained" 
              color="primary"
              startIcon={<FontAwesomeIcon icon={faSave} />}
            >
              تصدير إلى Excel
            </Button>
          </div>
          <table className="governorates-table">
            <thead>
              <tr>
                <th>المحافظة</th>
                <th>اجمالي الفواتير</th>
              </tr>
            </thead>
            <tbody>
              {renderTable(totalGovernoratesData, loadingTotal, "اليوم")}
            </tbody>
          </table>
        </TabPanel>

        {/* New governorates */}
        <TabPanel>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">اجمالي المحافظات حاله جديدة</h3>
            <Button 
              onClick={() => handleExportToExcel(newGovernoratesData.data)} 
              variant="contained" 
              color="primary"
              startIcon={<FontAwesomeIcon icon={faSave} />}
            >
              تصدير إلى Excel
            </Button>
          </div>
          <table className="governorates-table">
            <thead>
              <tr>
                <th>المحافظة</th>
                <th>اجمالي الفواتير</th>
              </tr>
            </thead>
            <tbody>
              {renderTable(newGovernoratesData, loadingNew, "حالة جديدة")}
            </tbody>
          </table>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default GovernoratesTable;
